import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {UrlHelperService} from '@app/service/url-helper.service';
import {BehaviorSubject, firstValueFrom, Observable} from 'rxjs';
import {indicate} from '@app/shared/util/rxjs-util';
import {FreeConfigurationCsvItem, FreeConfigurationPdf} from '@app/model/configuration.model';
import {BlobHelperService} from '@app/service/blob-helper.service';
import {ArticleView} from '@app/model/article-view.model';

@Injectable({
	providedIn: 'root'
})
export class ArticleService {
	#isLoading$ = new BehaviorSubject(false);

	// eslint-disable-next-line @typescript-eslint/member-ordering
	readonly isLoading$ = this.#isLoading$.asObservable();

	constructor(private http: HttpClient, private urlHelper: UrlHelperService, private blobHelper: BlobHelperService) {
	}

	search(searchTerm: string): Observable<ArticleView[]> {
		const url = this.urlHelper.prepareApiPath('articles', 'search');
		const params = new HttpParams().set('term', searchTerm);
		return this.http.get<ArticleView[]>(url, {params}).pipe(
			indicate(this.#isLoading$)
		);
	}

	async exportCsv(items: FreeConfigurationCsvItem[]): Promise<void> {
		const url = this.urlHelper.prepareApiPath('configurations', 'csv', 'free');
		const headers = {'Content-Type': 'application/json', 'Accept': 'text/csv'};
		const csv = await firstValueFrom(this.http.post(url, items, {headers, responseType: 'blob'}));
		this.blobHelper.open(csv);
	}

	async exportPdf(items: FreeConfigurationPdf): Promise<void> {
		const url = this.urlHelper.prepareApiPath('configurations', 'pdf', 'free');
		const headers = {'Content-Type': 'application/json', 'Accept': 'application/pdf'};
		const csv = await firstValueFrom(this.http.post(url, items, {headers, responseType: 'blob'}));
		this.blobHelper.open(csv);
	}
}
